var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export function convertFromUnixTimeStamp(timestamp)
{
    var date = new Date(timestamp*1000);
    return months[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();
}